import { insertOrUpdateBlock } from "@blocknote/core";
import { createReactBlockSpec } from "@blocknote/react";
import { Button } from "@mantine/core";
import { Image } from "@phosphor-icons/react";
import { useBoolean } from "usehooks-ts";
import { BlockEditorSchema } from "../BlockInput";
import { YOUTUBE_CONFIG } from "./config";
import { YoutubeEmbedModal } from "./YoutubeEmbedModal";
import { YoutubePreview } from "./YoutubePreview";

export const BlockNoteYoutube = createReactBlockSpec(YOUTUBE_CONFIG, {
  toExternalHTML: ({ block }) => {
    const { videoId, previewWidth, textAlignment, fullWidth } = block.props;
    return (
      <div style={{ textAlign: textAlignment }}>
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          style={{
            width: fullWidth ? "100%" : previewWidth,
            maxWidth: "100%",
            aspectRatio: "16/9",
          }}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    );
  },
  render: ({ block, editor }) => {
    const {
      props: { videoId },
    } = block;
    const { value, setTrue, setFalse } = useBoolean(!videoId);

    if (videoId) return <YoutubePreview block={block} editor={editor} />;
    return (
      <>
        <Button
          variant="filled"
          onMouseDown={(e) => e.preventDefault()}
          onClick={setTrue}
        >
          Add Youtube Url
        </Button>
        <YoutubeEmbedModal block={block} opened={value} onClose={setFalse} />
      </>
    );
  },
});

export const insertBlockNoteYoutube = (editor: BlockEditorSchema) => ({
  title: "Youtube",
  onItemClick: () => {
    insertOrUpdateBlock(editor, { type: "youtube" });
  },
  group: "Media",
  icon: <Image />,
  subtext: "Add an image to your content",
});
